import React from "react";
import { CustomButton } from "../../../../components";
import { IoIosArrowRoundForward } from "react-icons/io";
import styles from "./PayNow.module.scss";
import EMIsAPI from "../../../../services/emi-api";
import { rozarLoanPayment } from "../../../../lib/payments";

export default function PayNow(props) {
  const { loanSummary } = props;
  const { createOrderPaymentAPI } = new EMIsAPI();

  const handlePaymentOrder = async () => {
    const res = await createOrderPaymentAPI(loanSummary.amountToBeRepayed);
    if (res.statusCode === 200) {
      await rozarLoanPayment(res.data);
    }
  };

  return (
    <div className={styles.totalAmount}>
      <div>
        <p>Total</p>
        <h5>₹{loanSummary.amountToBeRepayed}</h5>
        <span className={styles.taxText}>Inclusive of all taxes</span>
      </div>
      <div>
        <CustomButton floating={false} text="Pay Now" endIcon={<IoIosArrowRoundForward size={30} />} onClick={handlePaymentOrder} />
      </div>
    </div>
  );
}
